import { IconOptions } from 'primereact/utils';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const CertificatesOutlineIcon = (options: IconOptions) => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 62 62'
      fill='currentcolor'
      xmlns='http://www.w3.org/2000/svg'
      {...options.iconProps}
    >
      <g opacity='0.8' fill='currentcolor' fillRule='nonzero'>
        <path d='M19.40039,5c-3.53,0 -6.40039,2.76969 -6.40039,6.17969v35.64062c0,3.41 2.87039,6.17969 6.40039,6.17969h0.61914c-0.397,-0.821 -0.85453,-2.077 -1.01953,-3h-0.00195c-1.68899,-0.13091 -2.91797,-1.50034 -2.91797,-3.17969v-35.64062c0,-1.77 1.49031,-3.20898 3.32031,-3.20898h27.19922c1.83,0 3.32031,1.43898 3.32031,3.20898v35.64062c0,1.77 -1.49031,3.20898 -3.32031,3.20898h-6.70898c-0.15,1.05 -0.46016,2.0507 -0.91016,2.9707h7.61914c3.53,0 6.40039,-2.76969 6.40039,-6.17969v-35.64062c0,-3.41 -2.87039,-6.17969 -6.40039,-6.17969zM21.5,15.53711c-0.828,0 -1.5,0.671 -1.5,1.5c0,0.829 0.672,1.5 1.5,1.5h21c0.828,0 1.5,-0.671 1.5,-1.5c0,-0.829 -0.672,-1.5 -1.5,-1.5zM21.5,23c-0.828,0 -1.5,0.671 -1.5,1.5c0,0.829 0.672,1.5 1.5,1.5h15c0.828,0 1.5,-0.671 1.5,-1.5c0,-0.829 -0.672,-1.5 -1.5,-1.5zM29.5,41c-4.14,0 -7.5,3.36 -7.5,7.5c0,1.98 0.7693,3.77914 2.0293,5.11914c0.01,2.19 0,6.91016 0,6.91016c0,0.22 0.55102,0.51992 0.79102,0.41992c2.71,-1.12 4.70898,-1.96875 4.70898,-1.96875c0,0 1.98164,0.85898 4.68164,1.95898c0.24,0.1 0.78906,-0.19992 0.78906,-0.41992v-6.93945c1.25,-1.34 2,-3.12008 2,-5.08008c0,-4.14 -3.36,-7.5 -7.5,-7.5zM29.51953,45.10938c1.86,0 3.37109,1.51109 3.37109,3.37109c0,1.86 -1.51109,3.36914 -3.37109,3.36914c-1.87,0 -3.37891,-1.50914 -3.37891,-3.36914c0,-1.86 1.50891,-3.37109 3.37891,-3.37109z' />
      </g>
    </svg>
  );
};

export default CertificatesOutlineIcon;
